// import React from "react";
// import MetricChart from "@components/ui/charts/MetricChart";
// import { useTranslation } from "react-i18next";

// const chartLabels = {
//   steps: { actual: "Actual Steps", goal: "Steps Goal" },
//   calories: {
//     actual: "Actual Calorie burnt",
//     goal: "Advised Calorie burnt",
//     intakeGoal: "Advise Calorie Intake",
//   },
//   activeMinutes: { actual: "Active Time", goal: "Active Time Goal" },
// };

// const ChartSection = ({
//   activeChartTab,
//   setActiveChartTab,
//   chartData,
//   isMobile,
//   goals,
// }) => {
//   const { t } = useTranslation();
//   return (
//     <div className="bg-white rounded-2xl p-6">
//       <div className="flex items-center justify-center gap-5">
//         <div className="flex items-center justify-center gap-1">
//           <div className="bg-[#05CFE6] w-4 h-4 rounded-full"></div>
//           <h2 className="text-[12px] font-[600] font-[Lato] text-[#444444]">
//             {t(chartLabels[activeChartTab]?.actual)}
//           </h2>
//         </div>

//         <div className="flex items-center justify-center gap-1 my-2">
//           <div className="bg-[#FF8B38] w-4 h-4 rounded-full"></div>
//           <h2 className="text-[12px] font-[600] font-[Lato] text-[#444444]">
//             {t(chartLabels[activeChartTab]?.goal)}
//           </h2>
//         </div>

//          {
//           activeChartTab ==="calories" &&
//           <div className="flex items-center justify-center gap-1">
//           <div className="bg-[#486608ff] w-4 h-4 rounded-full"></div>
//           <h2 className="text-[12px] font-[600] font-[Lato] text-[#444444]">
//             {t(chartLabels[activeChartTab]?.intakeGoal)}
//           </h2>
//         </div>}
//       </div>

//       {/* Chart Tabs */}
//       <div className="flex flex-col md:flex-row bg-white rounded-full p-1 md:border md:border-[#E9E9E9] w-full gap-1 mt-1 mb-3">
//         {["steps", "calories", "activeMinutes"].map((tab) => (
//           <button
//             key={tab}
//             className={`${
//               activeChartTab === tab
//                 ? "bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white"
//                 : "text-gray-600 hover:bg-gray-100"
//             } px-4 py-2 rounded-full text-[10px] md:text-[12px] font-medium flex-1 border border-[#E9E9E9] md:border-none capitalize`}
//             onClick={() => setActiveChartTab(tab)}
//           >
//             {tab === "activeMinutes" ? t("Active Time") : t(tab)}
//           </button>
//         ))}
//       </div>

//       {/* Chart */}
//       {chartData[activeChartTab]?.length > 0 ? (
//         <MetricChart
//           data={chartData}
//           activeTab={activeChartTab}
//           isMobile={isMobile}
//           advisedActiveTime={goals?.goal_active_minutes}
//           advisedCaloriesBurnt={goals?.goal_calories}
//           advisedSteps={goals?.step_goal}
//           targetDailyCalories={goals?.target_daily_calories}
//         />
//       ) : (
//         <div className="flex items-center justify-center h-[300px]">
//           <p className="text-gray-500">No chart data available for this week</p>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ChartSection;

import React, { useState } from "react";
import MetricChart from "@components/ui/charts/MetricChart";
import { useTranslation } from "react-i18next";

const chartLabels = {
  steps: {
    actual: "Actual Steps",
    goal: "Steps Goal",
  },
  calories: {
    actual: "Actual Calorie burnt",
    goal: "Advised Calorie burnt",
    intakeGoal: "Advise Calorie Intake",
  },
  activeMinutes: {
    actual: "Active Time",
    goal: "Active Time Goal",
  },
};

const ChartSection = ({
  activeChartTab,
  setActiveChartTab,
  chartData,
  isMobile,
  goals,
}) => {
  const { t } = useTranslation();
  // Tooltip descriptions for each type
  const tooltipDescriptions = {
    steps: {
      actual: t(
        "The actual number of steps you've taken during the selected time period. This helps track your daily physical activity."
      ),
      goal: t(
        "Your personalized daily step target based on your fitness goals and health profile. Aim to reach this for optimal health benefits."
      ),
    },
    calories: {
      actual: t(
        "Total calories burned through physical activity and metabolic processes throughout the day."
      ),
      goal: t(
        "Recommended daily calorie burn target to achieve your weight management and fitness objectives."
      ),
      intakeGoal: t(
        "Suggested daily calorie consumption to maintain, lose, or gain weight based on your health goals and activity level."
      ),
    },
    activeMinutes: {
      actual: t(
        "Time spent in moderate-to-vigorous physical activity that increases your heart rate and breathing."
      ),
      goal: t(
        "Daily target for active minutes to meet health guidelines and achieve fitness improvements."
      ),
    },
  };

  // Simple Tooltip Component
  const SimpleTooltip = ({ type, children, position = "top" }) => {
    const [showTooltip, setShowTooltip] = useState(false);

    // Get tooltip content based on active tab and type
    const getTooltipContent = () => {
      if (
        !tooltipDescriptions[activeChartTab] ||
        !tooltipDescriptions[activeChartTab][type]
      ) {
        return "";
      }
      return tooltipDescriptions[activeChartTab][type];
    };

    const tooltipContent = getTooltipContent();

    if (!tooltipContent) {
      return children;
    }

    const positionClasses = {
      top: "bottom-full left-1/2 transform -translate-x-1/2 mb-2",
      bottom: "top-full left-1/2 transform -translate-x-1/2 mt-2",
    };

    const arrowClasses = {
      top: "top-full left-1/2 transform -translate-x-1/2 border-4 border-t-gray-800 border-r-transparent border-b-transparent border-l-transparent",
      bottom:
        "bottom-full left-1/2 transform -translate-x-1/2 border-4 border-b-gray-800 border-r-transparent border-t-transparent border-l-transparent",
    };

    return (
      <div className="relative inline-block">
        <div
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          className="cursor-text inline-flex items-center"
        >
          {children}
        </div>
        {showTooltip && (
          <div
            className={`absolute z-50 ${positionClasses[position]} w-64 p-3 text-xs bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white rounded-lg shadow-lg`}
          >
            <div className="font-semibold mb-1">
              {t(chartLabels[activeChartTab]?.[type] || type)}
            </div>
            <div className="bg-white rounded-md p-2 text-black font-[Lato]">
              {t(tooltipContent)}
            </div>
            <div className={`absolute ${arrowClasses[position]}`} />
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="bg-white rounded-2xl p-6">
      {/* Legend with Tooltips */}
      <div className="flex items-center justify-center gap-5 flex-wrap">
        {/* Actual Legend with Tooltip */}
        <SimpleTooltip type="actual">
          <div className="flex items-center justify-center gap-1">
            <div className="bg-[#05CFE6] w-4 h-4 rounded-full"></div>
            <h2 className="text-[12px] font-[600] font-[Lato] text-[#444444]">
              {t(chartLabels[activeChartTab]?.actual)}
            </h2>
          </div>
        </SimpleTooltip>

        {/* Goal Legend with Tooltip */}
        <SimpleTooltip type="goal">
          <div className="flex items-center justify-center gap-1 my-2">
            <div className="bg-[#FF8B38] w-4 h-4 rounded-full"></div>
            <h2 className="text-[12px] font-[600] font-[Lato] text-[#444444]">
              {t(chartLabels[activeChartTab]?.goal)}
            </h2>
          </div>
        </SimpleTooltip>

        {/* Intake Goal Legend with Tooltip (only for calories) */}
        {activeChartTab === "calories" && (
          <SimpleTooltip type="intakeGoal">
            <div className="flex items-center justify-center gap-1">
              <div className="bg-[#486608ff] w-4 h-4 rounded-full"></div>
              <h2 className="text-[12px] font-[600] font-[Lato] text-[#444444]">
                {t(chartLabels[activeChartTab]?.intakeGoal)}
              </h2>
            </div>
          </SimpleTooltip>
        )}
      </div>

      {/* Chart Tabs */}
      <div className="flex flex-col md:flex-row bg-white rounded-full p-1 md:border md:border-[#E9E9E9] w-full gap-1 mt-1 mb-3">
        {["steps", "calories", "activeMinutes"].map((tab) => (
          <button
            key={tab}
            className={`${
              activeChartTab === tab
                ? "bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white"
                : "text-gray-600 hover:bg-gray-100"
            } px-4 py-2 rounded-full text-[10px] md:text-[12px] font-medium flex-1 border border-[#E9E9E9] md:border-none capitalize`}
            onClick={() => setActiveChartTab(tab)}
          >
            {tab === "activeMinutes" ? t("Active Time") : t(tab)}
          </button>
        ))}
      </div>

      {/* Chart */}
      {chartData[activeChartTab]?.length > 0 ? (
        <MetricChart
          data={chartData}
          activeTab={activeChartTab}
          isMobile={isMobile}
          advisedActiveTime={goals?.goal_active_minutes}
          advisedCaloriesBurnt={goals?.goal_calories}
          advisedSteps={goals?.step_goal}
          targetDailyCalories={goals?.target_daily_calories}
        />
      ) : (
        <div className="flex items-center justify-center h-[300px]">
          <p className="text-gray-500">No chart data available for this week</p>
        </div>
      )}
    </div>
  );
};

export default ChartSection;
